import React, { useState, useRef, useEffect } from 'react';
import './home.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';

import {
    LazyLoadImage,
    LazyLoadComponent,
} from 'react-lazy-load-image-component';

// Assets
// Background video
const BannerBg = require('./videos/home-page-video.mp4');
const BannerBg_LazyLoadImg = require('./img/home-lazyload.png');

// Gifs
import homeGif from './gifs/home-gif.gif'

// Images
import actionImage1 from './img/action_image1.png'
import actionImage2 from './img/action_image2.png'

import cardImage1 from './img/material-symbols_speed-outline.png'
import cardImage2 from './img/speed-icon.png'
import cardImage3 from './img/coins-icon.png'
import cardImage4 from './img/car-icon.png'

import logoImage2 from './img/USDA.png'
import logoImage3 from './img/NASA.png'
import logoImage4 from './img/NSF.png'

import swiperPic1 from './img/Marta.png'
import swiperPic2 from './img/Daniel.png'
import swiperPic3 from './img/John.png'
import swiperPic4 from './img/Francis.png'

import partner1 from './img/partners/Clay.png'
import partner1_testimonial from './img/partners/clay-testimonial.png'
import partner2 from './img/partners/DNRC.png'
import partner3 from './img/partners/ESRI.png'
import partner4 from './img/partners/TWC.png'
import partner5 from './img/partners/ISA.png'
import partner6 from './img/partners/ForeFlight.png'
import partner7 from './img/partners/CalFire.png'
import partner8 from './img/partners/NVIDIA.png'
import partner9 from './img/partners/35Mules.png'
import partner10 from './img/partners/NSWRural.png'
import partner11 from './img/FFS.png'
import partner12 from './img/partners/AlertCalifornia.png'
import partner13 from './img/partners/EY.png'
import partner14 from './img/partners/IdahoDP.png'
import partner15 from './img/partners/WEF.png'
import partner16 from './img/partners/EFL-Logo.png'
import partner17 from './img/partners/NASDAQ-Logo.png'

// Custom
import nasdaqPic from './img/partners/nasdaqPic.png'
import eflPic from './img/partners/eflPic.png'


// Info Card
interface InfoCardProps {
    image: string;
    text: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ image, text }) => (
    <div className='fnn-infoCard'>
        <img className="card-image1" alt="card" src={image} />
        <h2 className='the-h2'>{text}</h2>
    </div>
);

// Swiper Card
export interface SwiperCardProps {
    imageSrc: string;
    name: string;
    position: string;
    quote: string;
}

const SwiperCard: React.FC<SwiperCardProps> = ({ imageSrc, name, position, quote }) => (
    <div className='swiper-info'>
        <div className='swiper-pic-and-name'>
            <img className="swiper-pic" alt={`${name} headshot`} src={imageSrc} />
            <div className='swiper-nameAndPosition'>
                <h1>{name}</h1>
                <h2>{position}</h2>
            </div>
        </div>
        <p className='the-h2'>{quote}</p>
    </div>
);

// Partner array
const partners = [
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
    partner8,
    partner9,
    partner10,
    partner11,
    partner12,
    partner13,
    partner14,
    partner15,
    partner16,
    partner17
];

const popupContents = [
    {
        name: "Clay Electric",
        image: partner1,
        description: `FNN™ is collaborating with Clay Electric’s Power Delivery group to explore joint Department of Energy grant opportunities to increase resiliency and efficiency.`,
        link: 'https://www.clayelectric.com'
    },
    {
        name: "DNRC",
        image: partner2,
        description: `FNN™ has deployed sensors in Montana and is planning to expand coverage and integration for the 2025 fire season.`,
        link: 'https://dnrc.mt.gov/'
    },
    {
        name: "ESRI",
        image: partner3,
        description: `As a startup partner with Esri, FNN™ uses ArcGIS interactive dashboards to display HRL™ data, providing real-time situational awareness for clients.`,
        link: 'https://www.esri.com'
    },
    {
        name: "Weather Channel",
        image: partner4,
        description: `FNN’s elite lightning data will be featured by The Weather Channel, initially covering the state of Florida, with plans to expand coverage nationwide.`,
        link: 'https://weather.com'
    },
    {
        name: "ISA",
        image: partner5,
        description: `FNN™ is partnering with one of Brazil’s largest utility companies, based in São Paulo, to deliver actionable intelligence to its Power Delivery group through advanced lightning data and electric field analysis.`,
        link: 'https://www.isa.co/en/'
    },
    {
        name: "ForeFlight",
        image: partner6,
        description: `FNN™ is a strategic partner of ForeFlight, the world’s leading iOS-based pilot mapping application. FNN™ integrates proprietary High-Risk Lightning™ (HRL™) data as a custom map layer, enabling aerial firefighting crews to scan for probable wildfire hotspots.`,
        link: 'https://www.foreflight.com'
    },
    {
        name: "CAL FIRE",
        image: partner7,
        description: `FNN™ has worked closely with CAL FIRE leadership to deploy HRL™ sensors across Northern California, capable of pinpointing lightning-ignited wildfires within 40 seconds.`,
        link: 'https://www.fire.ca.gov'
    },
    {
        name: "HiPerGator",
        image: partner8,
        description: `FNN™ collaborates with NVIDIA’s co-founder to utilize the University of Florida’s NVIDIA-powered supercomputer, the HiPerGator, for accelerated wildfire modeling and analysis.`,
        link: 'https://www.rc.ufl.edu'
    },
    {
        name: "NextEra Energy (FPL)",
        image: partner9,
        description: `Selected from hundreds of applicants, FNN™ joined the exclusive six-company cohort at 35 Mules—the innovation hub of the U.S.’s largest utility, NextEra Energy (FPL). With their support, FNN™ now sells to major utilities across Florida.`,
        link: 'https://www.nexteraenergy.com'
    },
    {
        name: "Australian Government",
        image: partner10,
        description: `Funded by the Australian government, FNN™ is installing HRL™ sensors around Canberra to help protect the region from lightning-ignited wildfires.`,
        link: 'https://www.dcceew.gov.au'
    },
    {
        name: "Florida Forest Service",
        image: partner11,
        description: `Since 2021, FNN™ has partnered with FFS to support wildfire detection. In the 2024 fire season alone, FNN™ successfully located all 168 lightning-ignited fires in Florida, with HRL™ data also supporting FFS’s aerial response crews.`,
        link: 'https://www.fdacs.gov/Divisions-Offices/Florida-Forest-Service'
    },
    {
        name: "Alert California",
        image: partner12,
        description: `FNN’s HRL™ data is being integrated with wildfire camera systems, such as AlertCalifornia, to direct camera views toward likely ignition points. This integration will expand to Idaho and Montana.`,
        link: 'https://alertcalifornia.org'
    },
    {
        name: "Ernst & Young",
        image: partner13,
        description: `After winning the 2021 Microsoft AI for Big Data Challenge—outcompeting over 6,000 teams—FNN™ received partner-level consulting from Ernst & Young (EY) to scale wildfire mapping solutions.`,
        link: 'https://www.ey.com'
    },
    {
        name: "Idaho Government",
        image: partner14,
        description: ` FNN™ has deployed HRL™ sensors across Idaho in preparation for the 2025 wildfire season.`,
        link: 'https://www.idl.idaho.gov'
    },
    {
        name: "World Economic Forum",
        image: partner15,
        description: `In January 2024, FNN™ leadership took the stage at the World Economic Forum to present its breakthrough wildfire technology to thousands of global leaders.`,
        link: 'https://www.weforum.org'
    },
    {
        name: "Endless Frontier Labs",
        image: partner16,
        description: `FNN™ was competitively selected for the prestigious Endless Frontier Labs program, where we refined our strategy, validated technology, and engaged top-tier investors. Graduating from EFL positioned FNN™ as a standout leader in AI-driven wildfire prevention and deep technology innovation.`,
        link: 'https://endlessfrontierlabs.com/startups/'
    },
    {
        name: "Nasdaq",
        image: partner17,
        description: `FNN™ was selected for the highly competitive Nasdaq Milestone Makers program, focused on advancing the 13th UN Sustainable Development Goal. During the program, FNN™ refined its financial strategy to accelerate deployment of its technology and scale its impact.`,
        link: 'https://nasdaqcenter.org/2024/10/08/milestone-makers-fall-2024-c1/'
    }
];



const Home = () => {

    // Section for the video and its lazyLoad functionality
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    /* Section for the Partners Popup */
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const [popupContent, setPopupContent] = useState<{
        name: string;
        image?: string;
        description: string;
        link: string;
    } | null>(null);

    const popupRef = useRef<HTMLDivElement>(null);

    const handlePartnerClick = (e: React.MouseEvent<HTMLImageElement>, index: number) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const popupWidth = 240; // approximate or match .popup-bubble width in px (15rem ≈ 240px)
        const popupHeight = 150; // estimated popup height (adjust as needed)

        let x = rect.left + rect.width / 2;
        let y = rect.top;

        // Adjust X to stay within viewport
        if (x - popupWidth / 2 < 0) {
            x = popupWidth / 2 + 30;
        } else if (x + popupWidth / 2 > window.innerWidth) {
            x = window.innerWidth - popupWidth / 2 - 50;
        }

        // Adjust Y if popup would go above the viewport
        if (y - popupHeight < 350) {
            if (index === 5 || index === 10 || index === 15 || index === 16)
                y = rect.bottom + popupHeight + 280;
            else if (index === 1 || index === 2 || index === 13)
                y = rect.bottom + popupHeight + 150; // place below the image instead
            else if (index === 8 || index === 4 || index === 12)
                y = rect.bottom + popupHeight + 230;
            else
                y = rect.bottom + popupHeight + 180; // place below the image instead
        }

        setPopupPosition({ x, y });
        setPopupContent(popupContents[index] || null);

        setShowPopup(true);
    };

    const closePopup = () => setShowPopup(false);

    /* Section for controlling how many testimonials there are per view */
    const [slidesPerView, setSlidesPerView] = useState(1);

    useEffect(() => {
        const calculateSlides = () => {
            const containerWidth = window.innerWidth * 0.95;

            // Dynamically assign card width based on breakpoints
            let cardWidth;

            if (window.innerWidth >= 1450) {
                cardWidth = 640; // 40rem
            } else if (window.innerWidth >= 1040) {
                cardWidth = 448; // 28rem
            } else if (window.innerWidth >= 450) {
                cardWidth = 352; // 22rem
            } else {
                cardWidth = 300; // 22rem
            }

            const spacing = 50; // matches spaceBetween in Swiper
            const raw = (containerWidth + spacing) / (cardWidth + spacing);
            const adjustedSlides = Math.floor(raw * 100) / 100;

            setSlidesPerView(adjustedSlides);
        };

        calculateSlides();
        window.addEventListener("resize", calculateSlides);

        return () => window.removeEventListener("resize", calculateSlides);
    }, []);


    return (
        <div className="home-container">

            <div className="home-hero-section">
                {!isVideoLoaded && (
                    <LazyLoadComponent
                        placeholder={<img src={BannerBg_LazyLoadImg} alt="" />}
                    >
                        <LazyLoadImage
                            src={BannerBg_LazyLoadImg}
                            alt="="
                            className="hero-image"
                        />
                    </LazyLoadComponent>
                )}

                <video
                    className={`hero-image ${isVideoLoaded ? '' : 'hidden'}`}
                    src={BannerBg}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setIsVideoLoaded(true)}
                />

                <div className="dark-overlay"></div> {/* ← Overlay */}

                <div className="home-info-wrapper">
                    <h1><strong>Stay Ahead of the Storm</strong><span className='tm-sign'>™</span></h1>
                    <h2>
                        Lightning is a major contributor to wildfire and utility damage worldwide. FNN™ is the 
                        sole provider of proprietary High-Risk-Lightning™ strike intelligence.
                    </h2>

                    <Link to="/about" className='the-button'>
                        <span>Learn More</span>
                    </Link>
                </div>
            </div>

            <div className="partner-marquee">
                <div className={`partner-track ${showPopup ? 'paused' : ''}`}>
                    {[...Array(2)].map((_, i) => (
                        <div className="partner-loop" key={i}>
                            {partners.map((src, index) => (
                                <img
                                    key={`${i}-${index}`}
                                    className="partner-image"
                                    alt={`partner ${index + 1}`}
                                    src={src}
                                    onClick={(e) => handlePartnerClick(e, index)}
                                />
                            ))}

                        </div>
                    ))}
                </div>
            </div>

            {showPopup && popupContent && (
                <div
                    ref={popupRef}
                    className="popup-bubble"
                    style={{
                        top: popupPosition.y + window.scrollY - 10,
                        left: popupPosition.x,
                        transform: `translate(-50%, -100%)`,
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <button className="close-bubble" onClick={closePopup}>X</button>
                    <div className="popup-content-for-home">
                        <img
                            src={
                                popupContent.description?.includes('Nasdaq Milestone')
                                    ? nasdaqPic
                                    : popupContent.description?.includes('Endless Frontier Labs')
                                        ? eflPic
                                        : popupContent.image ?? ''
                            }
                            alt="Partner"
                            className={`${popupContent.description?.includes('Nasdaq Milestone') ||
                                popupContent.description?.includes('Endless Frontier Labs')
                                ? 'partner-image2'
                                : 'partner-image'
                                }`}
                            style={{
                                marginBottom: '1rem',
                                cursor: 'default',
                                pointerEvents: 'none',
                            }}
                        />
                        <p>{popupContent.description}</p>
                        <a
                            href={popupContent.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: 'flex', width: '100%', alignItems: 'flex-start', color: '#28aae1' }}
                        >
                            {popupContent.name} Website
                        </a>
                    </div>
                </div>
            )}


            <div className="action-section">
                <div className='action-info-wrapper'>
                    <h1 className='the-h1'>FNN™ Delivers Actionable Intelligence in Real Time</h1>

                    <h2 className='the-h2'>FNN™ uses its proprietary, patented <span className='glow-blue'> High-Risk-Lightning™
                        detection network </span> to identify dangerous lightning strikes capable of causing wildfires or utility infrastructure damage. 
                        By integrating this data with live environmental and utility asset information, and applying advanced AI signal 
                        processing, FNN’s  <span className='glow-blue'> HRL™ identification and notification
                        services </span> enable rapid ignition detection and precise fault location—often within seconds.</h2>

                    <Link to="/hrl-mapping" className='the-button'>
                        <span>Learn More</span>
                    </Link>
                </div>

                <img className="action-image" alt="action background" src={homeGif} />
            </div>

            <div className="high-risk-section">
                <img className="action-image2" alt="action background" src={actionImage2} />
            </div>

            <div className="high-risk-section">
                <div className='high-risk-info-wrapper'>
                    <h1 className='the-h1'>High-Risk-Lightning™</h1>

                    <h2 className='the-h2'><span className='glow-blue'> High-Risk-Lightning™ (HRL™)</span> is FNN™’s proprietary detection
                        and classification solution designed to identify the most dangerous lightning events—those rare, long-duration strikes
                        capable of causing wildfires or utility infrastructure damage. Despite accounting for less than 5% of total lightning activity, 
                        these extreme events can last up to <span className='glow-blue'> 1,000 </span>times longer than typical strikes and often cause 
                        the most damage. Powered by patented sensor technology and AI-driven analysis, the <span className='glow-blue'> FNN™ HRL™ Detection 
                        Service </span> is the only system capable of detecting and classifying these high-impact events with speed and precision. Utilities 
                        and government agencies around the world depend on the HRL™ service for real-time risk intelligence and enhanced situational awareness.
                    </h2>

                    <Link to="/hrl-detector" className='the-button2'>
                        <span>Explore services</span>
                    </Link>
                </div>
            </div>

            <div className='fnn-infoCard-section-parent'>
                <h1 className='the-why-h1' style={{ color: 'white' }} >Why FNN™?</h1>

                <div className="fnn-infoCard-section">
                    <InfoCard
                        image={cardImage1}
                        text="Unlike others, FNN™ alerts before there are visible signs of a fire."
                    />
                    <InfoCard
                        image={cardImage2}
                        text="Track and deliver AI-enabled alerts on power asset health after HRL™ strikes."
                    />
                    <InfoCard
                        image={cardImage3}
                        text="Decreases firefighting costs, utility company losses, and insurance payouts."
                    />
                    <InfoCard
                        image={cardImage4}
                        text="Empower Power Delivery and Emergency teams to optimize dispatch and construction."
                    />
                </div>
            </div>


            <div className="sbir-section">
                <div className='sbir-info-wrapper'>
                    <h1 className='the-h1'>Sole-Source Supplier</h1>

                    <h2 className='the-h2 the-h22'>FNN™ received a sole-source procurement certification due to successful
                        <span className='glow-blue'> Small Business Innovation Research</span> (SBIR) research awards and it
                        is a powerful way for federal agencies to directly award contracts to small businesses that have completed
                        certain phases of the SBIR program—without a competitive bidding process. FNN™ has been supported by the

                        <span className='glow-blue'> National Science Foundation</span>, <span className='glow-blue'>US Department of Agriculture</span> , and <span className='glow-blue'>NASA</span>.</h2>

                    <a
                        href="https://seedfund.nsf.gov/awardees/history/details/?company=helios-pompano-inc"
                        className="the-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span>Learn More</span>
                    </a>

                </div>

                <div className='sbir-image-wrapper'>
                    <img className="sbir-logos" alt="action background" src={logoImage3} />
                    <img className="sbir-logos" alt="action background" src={logoImage2} />
                    <img className="sbir-logos" alt="action background" src={logoImage4} />
                </div>
            </div>

            <h1 className='the-h1-title'>Testimonials</h1>

            <Swiper
                slidesPerView={slidesPerView}
                spaceBetween={50}
                pagination={{ clickable: true }}
                initialSlide={1}
                centeredSlides={true}
                modules={[Pagination]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <SwiperCard
                        imageSrc={partner1_testimonial}
                        name="Chris E. Bryan, P.E."
                        position="Chief Engineer, Clay Electric"
                        quote="“We are collaborating on a project to leverage FNN™’s proprietary real-time High-Risk-Lightning™ 
                        (HRL™) to assess, predict, and mitigate the impacts of severe storms and lightning on critical infrastructure”"
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <SwiperCard
                        imageSrc={swiperPic4}
                        name="Francis Neeley"
                        position="State Aviation Operations Administrator"
                        quote="“It is very beneficial for us to concentrate our aerial fire mitigation efforts 
                            on those long-continuing-current lightning strikes that likely ignited fires...”"
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <SwiperCard
                        imageSrc={swiperPic1}
                        name="Dr. Marta Yebra"
                        position="Australian Bushfire Initiative"
                        quote="“Lightning ignition was responsible for over 90% of the area burned in the 2020 
                            Black Summer fires. We need the FNN™ detectors and service nationally. We placed an order”."
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <SwiperCard
                        imageSrc={swiperPic2}
                        name="Daniel R Munsey"
                        position="Fire Chief, San Bernardino County"
                        quote="“Rapid response to lightning-induced ignitions is a key focus outlined in our Community 
                            Wildfire Protection Plans (CWPPs), and the FNN™ solution serves as a valuable tool in fulfilling 
                            this objective”."
                    />
                </SwiperSlide>

                <SwiperSlide>
                    <SwiperCard
                        imageSrc={swiperPic3}
                        name="John Raulerson"
                        position="Florida Chief of Forest Protection"
                        quote="“We currently house 10 FNN™ detectors and use the AI-based HRL™ 
                            service. We aim to continue to facilitate the implementation”."
                    />
                </SwiperSlide>

            </Swiper>
        </div>
    )
}

export default Home
